export const GET_TRANSACTIONS = "getTransactions";
export const GET_ACCOUNTS = "getAccounts";
export const GET_COUNTERPARITES = "getCounterparties";
export const GET_TRANSACTION_TYPES = "getTransactionTypes";
export const GET_WORKSPACES = "getWorkspaces";
export const GET_CURRENCIES = "getCurrencies";
export const GET_PRIMARY_CURRENCY = "getPrimaryCurrency";
export const SAVE_TRANSACTION = "saveTransaction";
export const DELETE_TRANSACTION = "deleteTransaction";
export const SAVE_ACCOUNT = "saveAccount";
export const SAVE_COUNTERPARTY = "saveCounterparty";
export const SAVE_TRANSACTION_TYPE = "saveTransactionType";
export const SAVE_CURRENCY = "saveCurrency";
export const BEGIN_UPLOAD = "beginUpload";
export const END_UPLOAD = "endUpload";
export const ERROR = "ERROR";
export const CLEAR_ERROR = "CLEAR_ERROR";
export const CREATE_WORKSPACE = "createWorkspace";
export const GET_CURRENT_WORKSPACE = "getCurrentWorkspace";
export const SET_CURRENT_WORKSPACE = "setCurrentWorkspace";
export const GET_TEMPLATE_LIST = "getTemplateList";
export const SET_REPO_COLLECTION = "setRepoCollection";
export const GET_DASHBOARD_WIDGETS = "getDashboardWidgets";
export const SAVE_DASHBOARD_WIDGET = "saveDashboardWidget";
export const DELETE_DASHBOARD_WIDGET = "deleteDashboardWidget";
export const EDIT_DASHBOARD_WIDGET = "editDashboardWidget";
export const GET_CONFIGURATIONS = "getConfigurations";
export const DELETE_ACCOUNT = "deleteAccount";
export const DELETE_COUNTERPARTY = "deleteCounterparty";
export const DELETE_TRANSACTION_TYPE = "deleteTransactionType";
export const DELETE_CURRENCY = "deleteCurrency";
export const GET_DEFAULT_COUNTERPARTY = "getDefaultCounterparty";
